export default "__VITE_ASSET__DPNqAP3O__"